var map = {
	"./Personnel/router.js": "ThDw",
	"./Processaudit/router.js": "KoZZ",
	"./Purchase/router.js": "+GDj",
	"./Report/router.js": "GbWL",
	"./System/router.js": "cS9a",
	"./financial/router.js": "B1uS",
	"./router.js": "jPb3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D5e5";


//////////////////
// WEBPACK FOOTER
// ./src/components/page router\.js$
// module id = D5e5
// module chunks = 50